module.exports = __webpack_public_path__ + "static/media/4B4F2FE8-3EF9-40C3-B869-F89F1FB81DDA.0776d8e4.jpg";